<template>
    <div>
        <ui-section title="Resumo por equipe" class="mb-4" description="Confira dias, estrada e responsáveis de cada equipe antes de gerar as agendas.">
            <div class="pe-review">
                <div v-for="team in activeTeams" :key="team.key" class="pe-review__team ui-card" :style="{ borderTopColor: team.color }">
                    <div class="pe-review__head">
                        <strong>{{ team.name }}</strong>
                        <span class="ui-small" :class="team.member_ids.length ? 'ui-muted' : 'pe-error'">{{ team.member_ids.length ? editor.memberNames(team) : "sem responsáveis" }}</span>
                    </div>
                    <template v-if="editor.planOf(team)">
                        <div class="pe-team__totals">
                            <span><strong>{{ editor.planOf(team).totals.cases }}</strong> {{ editor.planOf(team).totals.cases === 1 ? "visita" : "visitas" }}</span>
                            <span>{{ editor.planOf(team).totals.days }} {{ editor.planOf(team).totals.days === 1 ? "dia" : "dias" }}</span>
                            <span>{{ editor.planOf(team).totals.estimated ? "≈ " : "" }}{{ editor.planOf(team).totals.km.toLocaleString("pt-BR") }} km</span>
                            <span>{{ editor.formatHoursText(editor.planOf(team).totals.hours) }} de estrada</span>
                            <span v-if="editor.planOf(team).totals.warnings" class="pe-warn">{{ editor.planOf(team).totals.warnings }} {{ editor.planOf(team).totals.warnings === 1 ? "aviso" : "avisos" }}</span>
                        </div>
                        <div class="pe-review__links">
                            <a :href="editor.planOf(team).maps_url" target="_blank" rel="noopener"><v-icon x-small>mdi-google-maps</v-icon> rota inteira</a>
                            <a v-for="day in editor.planOf(team).days.filter((item) => item.maps_url)" :key="day.index" :href="day.maps_url" target="_blank" rel="noopener">dia {{ day.index }}</a>
                        </div>
                    </template>
                    <div v-else class="ui-small pe-error">{{ editor.errorOf(team) || "Calculando…" }}</div>
                </div>
            </div>
            <ui-empty v-if="!activeTeams.length" text="Nenhuma equipe com casos. Inclua casos na etapa 1." />
        </ui-section>

        <ui-section title="Gerar agendas" description="Uma agenda presencial por visita, na data e no horário do roteiro, com os responsáveis de cada equipe. Gerar de novo atualiza as agendas marcadas; as realizadas não mudam.">
            <div class="pe-review__generate">
                <v-text-field v-model="editor.form.start_date" type="date" label="Saída (dia 1)" outlined dense hide-details style="max-width: 200px;" @change="editor.queueSave"></v-text-field>
                <span class="ui-small ui-muted">{{ generatedText }}</span>
            </div>
            <ul v-if="blockers.length" class="pe-review__blockers">
                <li v-for="item in blockers" :key="item" class="ui-small pe-error">{{ item }}</li>
            </ul>
            <p v-else-if="warnings" class="ui-small pe-warn mt-3 mb-0">{{ warnings }} {{ warnings === 1 ? "visita tem aviso" : "visitas têm avisos" }} na agenda (fora da janela ou do combinado). Dá para gerar assim mesmo; confira na etapa 3.</p>
            <div class="d-flex justify-end mt-4">
                <v-btn v-if="$allowed('prospect.meetings')" color="primary" depressed :loading="editor.generate.saving" :disabled="!!blockers.length" @click="editor.submitGenerate">
                    <v-icon left small>mdi-calendar-multiselect</v-icon>{{ generated ? "Atualizar agendas" : "Gerar agendas" }}
                </v-btn>
            </div>
        </ui-section>
    </div>
</template>

<script>
// Editor de roteiro, etapa 4: resumo de cada equipe (dias, estrada, links do
// Maps) e a geracao das agendas, com o que ainda impede gerar.
// O estado e os metodos ficam no ProspectTripEditor (inject "editor").
export default {
    name: "ProspectTripReview",

    inject: ["editor"],

    computed: {
        activeTeams() {
            return this.editor.teams.filter((team) => this.editor.countOf(team));
        },
        generated() {
            return this.editor.trip ? this.editor.trip.stops.filter((stop) => stop.meeting).length : 0;
        },
        generatedText() {
            const total = this.editor.stops.length;
            if (!this.generated) return `${total} ${total === 1 ? "visita" : "visitas"}, nenhuma agenda gerada ainda.`;
            return `${this.generated} de ${total} ${total === 1 ? "visita já tem" : "visitas já têm"} agenda.`;
        },
        blockers() {
            const list = [];
            if (!this.editor.stops.length) list.push("Inclua casos no roteiro (etapa 1).");
            if (!this.editor.form.start_date) list.push("Informe a data de saída.");
            this.activeTeams.filter((team) => !team.member_ids.length).forEach((team) => list.push(`Defina os responsáveis de ${team.name} (etapa 1).`));
            this.activeTeams.filter((team) => this.editor.errorOf(team)).forEach((team) => list.push(`${team.name}: ${this.editor.errorOf(team)}`));
            return list;
        },
        warnings() {
            return this.activeTeams.reduce((sum, team) => sum + ((this.editor.planOf(team) && this.editor.planOf(team).totals.warnings) || 0), 0);
        },
    },
};
</script>
